{
  "error-message-wrapper": {
    "text": {
      "custom": "{{ message }}",
      "email": "E-Mail ist ungültig",
      "format": "Falsches Format ({{ correctFormat }})",
      "inRange": "{{ nameOfThisControl }} muss zwischen {{ min }} und {{ max }} liegen",
      "notEarlier": "{{ nameOfThisControl }} muss später sein als {{ nameOfAnotherControl }}",
      "min": "Der Eingabewert darf nicht kleiner als {{ min }} sein",
      "max": "Der Eingabewert darf nicht größer als {{ max }} sein",
      "minlength": "Der Eingabewert muss mindestens {{ requiredLength }} Zeichen enthalten",
      "maxlength": "Der Eingabewert darf höchstens {{ requiredLength }} Zeichen enthalten",
      "maxNumberSms": "Die maximale Anzahl von {{ max }} SMS wurde überschritten",
      "mustContainContent": "{{ nameOfInput }} muss {{ mustContainContent }} enthalten",
      "required": "Diese Angabe ist erforderlich",
      "sameValue": "{{ nameOfThisControl }} stimmt nicht mit {{ nameOfAnotherControl }} überein"
    }
  }
}
